import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { SystemNotification } from 'src/app/core/models/system-notification';
import { EMPTY_SN, NotificationApiService } from 'src/app/core/services/notification-api.service';

@Component({
    selector: 'app-notification-modal',
    standalone: false,
    templateUrl: './notification-modal.component.html',
    styleUrls: ['./notification-modal.component.scss']
})

export class NotificationModalComponent implements OnInit, OnDestroy {
    serverNotificationList: Array<SystemNotification> = EMPTY_SN;
    clientNotificationList: Array<SystemNotification> = EMPTY_SN;
    private notificationchange?: Subscription;

    constructor(
        private readonly activeModal: DynamicDialogRef,
        private readonly translate: TranslateService,
        private readonly notificationService: NotificationApiService) {
    }

    ngOnInit(): void {
        this.notificationchange = this.notificationService.notificationChange$
            .subscribe((notList: Array<SystemNotification>) => { 
                 this.clientNotificationList = notList.filter(n => !n.server);
                 this.serverNotificationList = notList.filter(n => n.server);
            });
    }

    closeModal() {
        this.activeModal.close()
    }

    ngOnDestroy(): void {
        this.notificationchange?.unsubscribe();
    }

    clearClientNotifications(): void {
        this.notificationService.clearNotifications(true);
    }

// TODO: Now that there is additional data carried in a notification, we could offer an action button/link
//    hasAction(notification: SystemNotification): boolean {
//        return notification.hasAction();
//    }
//    
//    performAction(notification: SystemNotification): void {
//        this.notificationService.performAction(notification);       
//    } 
}
